// extracted by mini-css-extract-plugin
export default {"menuScrollbar":"styles_menuScrollbar__zRZ7r","scrollbarHide":"styles_scrollbarHide__Y+WE2"};